let wishlistButton = document.querySelector(".wishlistButton");
let dropdownMenuWrapper = document.querySelector(".DropdownMenuWrapper");
//console.log("Try In Shop Wishlist: ", localStorage.getItem("tryInShop"));
//console.log(navigator.userAgent)

history.pushState = ((f) =>
  function pushState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event("pushstate"));
    window.dispatchEvent(new Event("shopify-wishlist:locationchange"));
    return ret;
  })(history.pushState);

history.replaceState = ((f) =>
  function replaceState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event("replacestate"));
    window.dispatchEvent(new Event("shopify-wishlist:locationchange"));
    return ret;
  })(history.replaceState);

window.addEventListener("popstate", () => {
  window.dispatchEvent(new Event("shopify-wishlist:locationchange"));
});

document.addEventListener("DOMContentLoaded", () => {
  initDropdown();
  addInfoMessage();
  initButtons();
  toggleNotifsWishlist();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);

  dropdownMenuWrapper.setAttribute("aria-hidden", "false");
  setTimeout(() => {
    dropdownMenuWrapper.setAttribute("aria-hidden", "true");
  }, 5000);

  initDropdown();
  addRedHeart();
  addInfoMessage();
  authorizeClick();
  toggleNotifsWishlist();
});

document.addEventListener("shopify-wishlist:init-product-dropdown", (event) => {
  //console.log('[Shopify Wishlist] Wishlist Dropdown Loaded ✅', event.detail.wishlist);
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  //console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

window.addEventListener("shopify-wishlist:locationchange", (event) => {
  //console.log('[Shopify Wishlist] Variant Change ✅');
  getVariantId();
  addRedHeart();
  authorizeClick();

  if (wishlistButton) wishlistButton.dataset.variantId = variantId;
});

const getVariantId = () => {
  const params = new URL(document.location).searchParams;

  if (params.get("variant")) {
    variantId = params.get("variant");
  } else {
    if (typeof firstAvailableVariant !== "undefined")
      variantId = firstAvailableVariant.id;
  }
  //console.log(variantId);
  if (typeof variantId !== "undefined") return variantId;
};

const authorizeClick = () => {
  /*
  const sizeSwitcher = document.querySelectorAll(
    ".csp-swatch-label[opt-pos='2']"
  );
  let option2 = firstAvailableVariant.option2;

  console.log("option2Variable:", option2);

  sizeSwitcher.forEach((size) => {
    size.addEventListener("click", () => {
      option2 = size.dataset.value;
    });
  });
  */

  if (wishlistButton !== null) {
    if (getWishlist().length < 3 && isAccess())
      wishlistButton.setAttribute("disabled", "true");
    else if (
      getWishlist().length == 3 &&
      !isGiftAccess() &&
      !wishlistContains(getVariantId())
    )
      wishlistButton.setAttribute("disabled", "true");
    else wishlistButton.removeAttribute("disabled");

    currentProduct.variants.forEach((variant) => {
      if (variantId == variant.id) {
        console.log("variant option2: ", variant.option2);

        /*
        if (variant.option2 !== option2) {
          if (wishlistButton) {
            wishlistButton.setAttribute("disabled", "true");
            return;
          }
        }
        */

        if (!variant.available) {
          if (wishlistButton) {
            wishlistButton.setAttribute("disabled", "true");
            return;
          }
        }
        if (wishlistContainsAccess() && !wishlistContains(getVariantId())) {
          if (wishlistButton) {
            wishlistButton.setAttribute("disabled", "true");
            return;
          }
        }
      }
    });
  }
};

const addInfoMessage = () => {
  let buttonWishlistWrapper =
    document.querySelector(".buttonWishlistWrapper") || null;

  if (getWishlist().length == 0 && !wishlistContainsAccess())
    message = `Remaining frames to add: 3`;
  else if (getWishlist().length == 1 && !wishlistContainsAccess())
    message = `Remaining frames to add: 2`;
  else if (getWishlist().length == 2 && !wishlistContainsAccess())
    message = `Remaining frames to add: 1`;
  else if (getWishlist().length == 3 && !wishlistContainsAccess())
    message = `Your Trylist is full`;
  else if (getWishlist().length == 4 && wishlistContainsAccess())
    message = `Your gift is selected`;
  else if (wishlistContainsAccess())
    message = `Your Trylist already contains a gift ! <br>Please remove your gift first to continue`;

  //console.log(getWishlist())

  buttonWishlistWrapper?.prepend(message);
};

const addRedHeart = () => {
  if (wishlistButton) {
    const varid = getVariantId();

    if (wishlistContains(varid)) {
      wishlistButton.classList.add("inTrylist");
    } else {
      wishlistButton.classList.remove("inTrylist");
    }
  }
};

const isGiftAccess = () => {
  let isGift = false;

  if (typeof currentProduct !== "undefined")
    if (currentProduct.tags.includes("ClickAndTryinGift")) isGift = true;

  return isGift;
};

const isAccess = () => {
  let isAccess = false;

  if (typeof currentProduct !== "undefined")
    if (currentProduct.tags.includes("Category_Accessories")) isAccess = true;

  return isAccess;
};

const wishlistContainsAccess = () => {
  let access = false;

  getWishlist().forEach((item) => {
    if (item.weight != 200) access = true;
  });
  return access;
};

const allowGiftSelection = () => {
  let selectGift = false;
  //console.log(wishlistContainsAccess())

  if (isWishlistFull(getWishlist())) {
    if (!wishlistContainsAccess()) {
      console.log("Choix du gift maintenant !");
      selectGift = true;
    } else {
      console.log("Wishlist contient un access !");
      selectGift = false;
    }
  }
  return selectGift;
};

const setupDropdown = (dropdown) => {
  const wishlist = getWishlist();
  let wishlistProductCards = [];
  let btnWishlistWrapper = `<div class="buttonWishlistWrapper"></div>`;
  let btnChoice = `<a class="Button Button--primary btnCoice" href="/collections/click-try-in-shop">Continue your choice</a>`;
  let btnGift = `<a class="Button Button--primary btnGift" href="/collections/select-your-gift">Select your gift*</a><p class="asterisqueDropdown">*Gift obtained in store for the purchase of one pair of the try list</p>`;
  let BtnStore = `<a class="Button Button--primary chooseStoreBtn" href="/pages/store-locator-click-try-in">Choose your store</a>`;

  if (wishlist.length > 0) {
    wishlist.forEach((variant) => {
      wishlistProductCards.push(`
      <div class="itemDropdownWrapper">
        <div class="itemDropdown">
          <img class="imgWishlistDropdown" src="${
            variant.featured_image ? variant.featured_image.src : ""
          }">
          <div class="infosItemDropdown">
            <h4 class="titleWishlistDropdown">${variant.name.split("-")[0]}</h4>
			<h5 class="subtitleWishlistDropdown">${variant.sku} ${
        variant.title != "Default Title" ? ": " + variant.title : ""
      }</h5>
          </div>
        </div>
        <div>
		  <i class="far fa-times-circle" data-variant-id="${variant.id}"></i>
        </div>
      </div>`);
    });

    let dropdownContent = wishlistProductCards.join("");

    dropdown.innerHTML = dropdownContent;
    dropdown.innerHTML += btnWishlistWrapper;
    let btnWishlistWrapperSet = document.querySelector(
      ".buttonWishlistWrapper"
    );

    if (
      wishlist.length > 0 &&
      wishlist.length < 3 &&
      !wishlistContainsAccess()
    ) {
      btnWishlistWrapperSet.innerHTML = btnChoice;
    } else if (wishlist.length == 4) {
      btnWishlistWrapperSet.innerHTML = BtnStore;
    }

    if (allowGiftSelection()) {
      btnWishlistWrapperSet.innerHTML = btnGift;
    }

    dropdown.classList.add("loaded");
  } else {
    dropdown.innerHTML = `
    <div class="originWishlistMsgContainer">
		<h3>Not sure? Select your 3 favorite pairs of glasses and schedule your personal appointment to try them on at our nearest partner optician.</h3>
	</div>
    <div class="buttonWishlistWrapper">
		<a class="Button Button--primary" href="/collections/click-try-in-shop">Choose your pairs </a>
	</div>`;
  }

  deleteVariant(wishlist);

  const event = new CustomEvent("shopify-wishlist:init-product-dropdown", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const deleteVariant = (wishlist) => {
  const deleteBtnWishlist =
    document.getElementsByClassName("fa-times-circle") || [];

  if (deleteBtnWishlist.length) {
    for (let btn of deleteBtnWishlist) {
      btn.addEventListener("click", (e) => {
        const variantToDelete = wishlist.find(
          (variant) => variant.id == e.target.dataset.variantId
        );
        const variantToDeleteIndex = wishlist.indexOf(variantToDelete);

        wishlist.splice(variantToDeleteIndex, 1);
        localStorage.removeItem(`trylist - ${variantToDelete.name}`);

        const event = new CustomEvent("shopify-wishlist:updated", {
          detail: { wishlist: wishlist },
        });
        document.dispatchEvent(event);
      });
    }
  }
};

const initDropdown = () => {
  let dropdown;

  if (document.body.offsetWidth < 1220) {
    dropdown = document.querySelector(".wishlistDropdownMobile");
  } else {
    dropdown = document.querySelector(".wishlistDropdown");
  }

  if (dropdown) setupDropdown(dropdown);
};

const isWishlistFull = (wishlist) => {
  if (wishlist.length < 3) {
    localStorage.setItem("tryInShop", false);
    return false;
  } else {
    localStorage.setItem("tryInShop", true);
    return true;
  }
};

const getWishlist = () => {
  const wishlist = [];
  const localStorageKeys = Object.keys(localStorage);

  localStorageKeys.forEach((key) => {
    if (key.includes("trylist")) {
      const wishlistItem = localStorage.getItem(key);
      wishlist.push(JSON.parse(wishlistItem));
    }
  });
  if (wishlist) return wishlist;
  return [];
};

const setWishlist = (array) => {
  if (array.length) {
    if (array.length <= 4) {
      array.forEach((variant) => {
        localStorage.setItem(
          `trylist - ${variant.name}`,
          `${JSON.stringify(variant)}`
        );
      });
    } else {
      console.log(message);
    }
  } else {
    const localStorageKeys = Object.keys(localStorage);

    localStorageKeys.forEach((key) => {
      if (key.includes("trylist")) {
        localStorage.removeItem(key);
      }
    });
  }

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return array;
};

const updateWishlist = (variant) => {
  const wishlist = getWishlist();
  //console.log(variant)

  let inWishlist = false;

  wishlist.forEach((element, index) => {
    //console.log(element.title, index);

    if (element.id == variant.id) {
      inWishlist = true;
      wishlist.splice(index, 1);
      localStorage.removeItem(`trylist - ${element.name}`);
      //console.log(element.title, variant.title, index);
    }
  });

  // OPTIMISER !!
  if (!inWishlist && variant.available) wishlist.push(variant);

  return setWishlist(wishlist);
};

const wishlistContains = (id) => {
  const wishlist = getWishlist();
  let inWishlist = false;

  wishlist.forEach((variant) => {
    if (variant.id == parseInt(id)) {
      inWishlist = true;
    }
  });
  return inWishlist;
};

const setupButtons = (wishlistButton) => {
  addRedHeart();
  authorizeClick();

  variantId = getVariantId();
  console.log(getWishlist().length);

  wishlistButton.addEventListener("click", () => {
    currentProduct.variants.forEach((variant) => {
      if (variantId == variant.id) {
        //console.log(isWishlistFull(getWishlist()))

        if (getWishlist().length < 3) {
          if (variant.available && !wishlistContainsAccess() && !isAccess()) {
            updateWishlist(variant);
          }
        } else if (getWishlist().length == 3) {
          if (!wishlistContainsAccess()) {
            if (variant.available) {
              if (isGiftAccess()) {
                updateWishlist(variant);
              } else if (wishlistContains(getVariantId())) {
                updateWishlist(variant);
              }
            }
          } else {
            if (wishlistContains(getVariantId()) && variant.available)
              updateWishlist(variant);
          }
        } else if (getWishlist().length == 4) {
          if (!wishlistContainsAccess()) {
            if (variant.available) updateWishlist(variant);
          } else {
            if (wishlistContains(getVariantId()) && variant.available)
              updateWishlist(variant);
          }
        }
      }
    });
  });
};

const initButtons = () => {
  const button = document.querySelector(".wishlistButton") || false;
  if (button) setupButtons(button);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const toggleNotifsWishlist = () => {
  let notifsWishlist = document.querySelector(".toggleNotifs");
  //console.log(notifsWishlist)

  if (getWishlist().length > 0 && document.body.offsetWidth < 1220) {
    notifsWishlist.removeAttribute("hidden");

    if (getWishlist().length == 3) {
      notifsWishlist.style.height = "12px";
      notifsWishlist.style.overflow = "visible";
      notifsWishlist.style.marginTop = "-26px";
      notifsWishlist.style.marginLeft = "-4px";
      notifsWishlist.innerHTML =
        "<path style='fill:#BF392C;' d='M232.986,17.729C227.578,6.624,216.316,0,202.901,0C172.326,0,150.641,33.034,140,53.879 C129.332,33.052,107.683,0.21,77.168,0.21c-19.357,0-33.393,13.791-33.393,32.492c0,33.166,31.634,54.807,95.227,54.807 s97.283-27.81,97.283-54.535C236.276,27.67,235.305,22.463,232.986,17.729z M82.559,50.65 c-9.258-5.531-12.557-11.726-12.557-15.699c0-5.075,5.399-8.751,12.837-8.751c17.922,0,40.849,29.438,48.558,43.842 C110.745,68.502,89.612,54.868,82.559,50.65z M208.79,39.668c-4.647,9.381-29.219,28.073-59.917,30.365 c7.745-14.404,30.715-43.842,48.357-43.842c6.826,0,10.746,2.958,12.111,5.723C210.426,34.12,210.243,36.736,208.79,39.668z'/><path style='fill:#EFC75E;' d='M280.048,87.552H0.021v70.024h8.751V280.07h262.526V157.577h8.751 C280.048,157.577,280.048,87.552,280.048,87.552z'/><path style='fill:#D7B354;' d='M8.772,157.568h262.526v17.502H8.772V157.568z'/><path style='fill:#BF392C;' d='M122.533,87.552h35.003v192.519h-35.003C122.533,280.071,122.533,87.552,122.533,87.552z'/><rect x='122.533' y='157.568' style='fill:#AC3327;' width='35.003' height='17.502'/>";
    } else if (getWishlist().length == 4) {
      notifsWishlist.style.height = "6px";
      notifsWishlist.style.overflow = "visible";
      notifsWishlist.style.marginTop = "-38px";
      notifsWishlist.style.marginLeft = "-8px";
      notifsWishlist.innerHTML = `
<path style="fill:#EE3840;" d="M445.841,201.423c0,152.012-171.608,292.797-171.608,292.797c-10.027,8.226-26.437,8.226-36.465,0
	c0,0-171.608-140.785-171.608-292.797c0-104.846,84.995-189.84,189.841-189.84S445.841,96.578,445.841,201.423z"/>
<path style="fill:#FFE1D6;" d="M256.001,296.934c-52.665,0-95.51-42.846-95.51-95.51s42.846-95.51,95.51-95.51
	s95.51,42.846,95.51,95.51S308.664,296.934,256.001,296.934z"/>
<g>
	<path style="fill:#11113F;" d="M256.001,0C144.935,0,54.576,90.359,54.576,201.424c0,36.373,9.386,74.987,27.896,114.767
		c14.616,31.409,34.94,63.649,60.411,95.826c43.178,54.547,85.749,89.691,87.54,91.16c7.171,5.883,16.375,8.825,25.579,8.825
		c9.204,0,18.407-2.942,25.579-8.825c1.791-1.47,44.361-36.613,87.539-91.16c25.47-32.176,45.795-64.416,60.411-95.826
		c18.51-39.78,27.896-78.392,27.896-114.767C457.424,90.359,367.065,0,256.001,0z M351.247,397.268
		c-41.647,52.697-83.942,87.653-84.361,87.997c-5.799,4.758-15.972,4.757-21.768,0.002c-0.422-0.346-42.716-35.302-84.363-87.999
		c-37.869-47.918-83.012-120.791-83.012-195.844c-0.001-98.292,79.965-178.258,178.257-178.258s178.258,79.966,178.258,178.258
		C434.258,276.476,389.116,349.35,351.247,397.268z"/>
	<path style="fill:#11113F;" d="M256.001,94.331c-59.051,0-107.093,48.042-107.093,107.094c0,59.051,48.042,107.093,107.093,107.093
		s107.093-48.042,107.093-107.093C363.093,142.373,315.051,94.331,256.001,94.331z M256.001,285.351
		c-46.278,0-83.927-37.649-83.927-83.927s37.649-83.928,83.927-83.928s83.927,37.65,83.927,83.928S302.277,285.351,256.001,285.351z
		"/>`;
    } else {
      notifsWishlist.style.height = "12px";
      notifsWishlist.style.overflow = "visible";
      notifsWishlist.style.marginTop = "-26px";
      notifsWishlist.style.marginLeft = "-5px";
      //notifsWishlist.setAttribute("class", "notifsWishlistTransition")
      notifsWishlist.innerHTML =
        "<path d='M258.844192 127.790368L145 241.63456 31.1558082 127.790368c-26.9461761-26.946176-26.9461761-70.6345598 0-97.5807359 26.9461762-26.94617613 70.6345598-26.94617613 97.5807358 0L145 46.4730881l16.263456-16.263456c26.946176-26.94617613 70.63456-26.94617613 97.580736 0 26.946176 26.9461761 26.946176 70.6345599 0 97.5807359z' stroke='#000' stroke-width='20' fill='#c23616' fill-rule='evenodd'/>";
    }
  } else notifsWishlist.setAttribute("hidden", "true");
};

// TEST CREATION COMMANDE AVEC LE CONTENU DE LA WISHLIST
/*

//const apitoken = 'Basic '+btoa('6c850ff967f14ad5ad22f94e5db33d57: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')
//console.log(apitoken)

const createWishlistOrder = async (url = "", data = {}) => {
  //const shopifyToken = btoa('6c850ff967f14ad5ad22f94e5db33d57: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')
  const xShopifyAccessToken = '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'
	
  const response = await fetch(url, {
    method: 'POST',
    mode: 'no-cors',
    //cache: 'reload',
    //credentials: 'omit',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Basic 6c850ff967f14ad5ad22f94e5db33d57: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',
      //'X-Shopify-Access-Token': xShopifyAccessToken,
      //'Access-Control-Allow-Origin': '*'
    },
    body: JSON.stringify(data)
  })
  console.log(response.json())
  return response.json()
}


const fetchProducts = async () => {
  const shopifyToken = btoa('6c850ff967f14ad5ad22f94e5db33d57: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')
  //console.log(shopifyToken)
  
  const response = await fetch("https://nathalieblancparis.myshopify.com/admin/api/2022-01/products.json", {
    method: 'GET',
    //mode: 'cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept': '/',
      'Content-Type': 'application/json',
      //'X-Shopify-Access-Token': "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",
      'Authorization': 'Basic NmM4NTBmZjk2N2YxNGFkNWFkMjJmOTRlNWRiMzNkNTc6c2hwYXRfYjYyODJmNDY4N2Y0NGYwMTRlYTQxMmY0ZTMxNTA0MDE=',
    }
  })
  console.log(response.json())
  return response.json()
}

fetchProducts()
*/

/*
const wishlist = document.querySelector(".wishlist");
console.log(wishlist);
*/
